<template>
  <div class="max-content">
    <p v-if="field.model === 'LeftHeader'">
      <b>
        <span v-if="field.isHtml" v-html="content" class="cell-content"> </span>
        <span v-else class="cell-content">{{ content }}</span>
      </b>
    </p>
    <p v-else-if="field.model === 'profile_pic'" class="picture-cell">
      <img
        v-if="row[field.model]"
        class="profile-picture"
        :src="convertToAbsolutePath(row[field.model])"
      />
    </p>
    <p v-else-if="field.model === 'date' && isJobTable">
      {{ jobDateString }}
    </p>
    <p v-else-if="field.model === 'birthday' && field.displayLabel == 'Age'">
      {{ getAge(row[field.model]) }}
    </p>
    <p v-else-if="row[field.model] !== null && fieldUseCurrency && isJobTable">
      {{ agencyCurrencySign }}{{ row[field.model].toFixed(2) }}
    </p>
    <p v-else-if="field.model === 'stripe_connect_id'">
      {{ row[field.model] ? "Yes" : "No" }}
    </p>
    <p
      v-else-if="field.model === 'date' && isApplicantTable && row[field.model]"
    >
      {{ new Date(row[field.model]).toDateString() }} at
      {{ new Date(row[field.model]).toLocaleTimeString() }}
    </p>
    <p
      v-else-if="(field.model === 'applicant_name' || field.model === 'applicant_name_status') && isApplicantTable"
      class="d-flex align-items-center"
    >
      <img
        v-if="row['applicant_profile_pic']"
        class="profile-picture mr-2"
        :src="convertToAbsolutePath(row['applicant_profile_pic'])"
      />
      {{ row[field.model] }}
      <span
        v-if="row.is_from_marketplace"
        class="material-icons manual-added pl-1 text-danger"
        v-tooltip="'External Agency'"
      >
        public
      </span>
      <span
        v-if="row.manually_added"
        class="material-icons manual-added pl-1"
        v-tooltip="'Manually Added'"
      >
        add_circle
      </span>
    </p>
    <span v-else-if="field.model === 'name' && isTemplateTable">
      {{ row[field.model] }}
      <span v-if="row.deactivated">(Deactivated)</span>
    </span>
    <p
      v-else-if="
        field.model === 'redirect_link' &&
        row[field.showIfModal] == field.showIfValue
      "
    >
      <a
        class="icon-button-table"
        :href="`application-form/${row.agency}/${row.id}`"
        target="blank"
      >
        <i class="material-icons"> launch </i>
      </a>
    </p>
    <span v-else-if="field.model === 'type' && field.showSectionType">
      {{ row[field.model] }}
      <span v-if="getSectionType(row.api)"
        >({{ getSectionType(row.api) }})</span
      >
    </span>
    <p v-else>
      <span
        v-if="field.isHtml && field.onClick"
        class="cell-content"
        :class="{ 'break-all': field.breakAll }"
        v-html="content"
        @click="field.onClick($event)"
      ></span>
      <span
        v-else-if="field.isHtml"
        class="cell-content"
        :class="{ 'break-all': field.breakAll }"
        v-html="content"
      ></span>
      <span
        v-else
        class="cell-content"
        :class="{ 'break-all': field.breakAll }"
        >{{ displayContent }} </span
      >
      <span
        v-if="noteModelOfField && row[noteModelOfField]"
        @click.stop="showNote(row)"
      >
        <i class="material-icons mt-1 sticky-note-icon">
          {{ field.noteIcon || "sticky_note_2" }}
        </i>
      </span>
      <span v-if="hasDiffWarning" v-tooltip="field.diffCheckTooltip">
        <i class="material-icons mt-1 change-icon"> warning </i>
      </span>
      <span
        v-if="hasShowMoreLessButton && !isDisplayFull"
        @click.stop="isDisplayFull = true"
        class="d-block"
      >
        <i class="material-icons">keyboard_double_arrow_down</i>
      </span>
      <span
        v-if="hasShowMoreLessButton && isDisplayFull"
        @click.stop="isDisplayFull = false"
        class="d-block"
      >
        <i class="material-icons">keyboard_double_arrow_up</i>
      </span>
    </p>
    <span
      v-if="field.previewModel && row[field.previewModel]"
      class="material-icons manual-added pl-1"
      v-tooltip="getHtmlText(row[field.previewModel])"
    >
      preview
    </span>
    <p v-if="transformNoteContent" class="description">
      <span>{{ transformNoteContent }}</span>
    </p>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { MAP_DIALOG_SECTION } from "../../constants/field-types";

export default {
  name: "TableCell",
  props: {
    content: [String, Number],
    field: Object,
    row: Object,
    listStatusColors: Array,
    isJobTable: Boolean,
    isApplicantTable: {
      type: Boolean,
      default: false,
    },
    isTemplateTable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      wordLengthLimit: 20, // If more than this, display Show More
      isDisplayFull: false,
      MAP_DIALOG_SECTION,
    };
  },
  computed: {
    ...mapGetters(["agencyCurrencySign"]),
    transformNoteContent() {
      if (!this.field || !this.field.transformNoteFunction) {
        return null;
      }
      return this.field.transformNoteFunction(this.row);
    },
    hasShowMoreLessButton() {
      if (typeof this.content !== "string") {
        return false;
      }
      const tokens = this.content.split(" ");
      return tokens.length > this.wordLengthLimit;
    },
    displayContent() {
      if (!this.hasShowMoreLessButton) {
        return this.content;
      }
      if (this.isDisplayFull) {
        return this.content;
      }
      const tokens = this.content.split(" ");
      return tokens.slice(0, this.wordLengthLimit).join(" ");
    },
    hasDiffWarning() {
      const field = this.field;
      if (field.diffCheckModel) {
        if (!this.content) {
          return false;
        }
        const value = this.row[field.model];
        if (!value) {
          return false;
        }
        const refValue = this.row[field.diffCheckModel];
        if (value != refValue) {
          return true;
        }
      }
      return false;
    },
    noteModelOfField() {
      const field = this.field;
      if (field.noteModel) {
        const noteModel = field.noteModel;
        if (noteModel === "text3") {
          return "clock_in_notes";
        }
        if (noteModel === "text4") {
          return "clock_out_notes";
        }
        if (noteModel === "text5") {
          return "admin_notes";
        }
        return noteModel;
      } else {
        return null;
      }
    },
    jobDateString() {
      const job = this.row;
      if (!job || !job.date) {
        return "";
      }
      return this.addTimeToDate(job.date).toDateString();
    },
    fieldUseCurrency() {
      if (!this.field || !this.field.model) {
        return false;
      }
      if (
        [
          "candidate_rate",
          "client_rate",
          "agency_fee",
          "per_booking_agency_fee",
          "per_booking_candidate_fee",
          "travel_fee",
          "rush_fee",
          "candidate_rush_fee",
          "admin_fee",
          "admin_fee_subtraction",
          "additional_fee",
          "total_client_charge",
          "total_candidate_pay",
        ].includes(this.field.model)
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    showNote(row) {
      if (this.field.showNoteFunc) {
        this.field.showNoteFunc(row);
      } else {
        this.showResultDialog({
          message: row[this.noteModelOfField],
          title: this.field.noteTitle,
        });
      }
    },
    getSectionType(api) {
      const section = Object.values(this.MAP_DIALOG_SECTION).find(
        (item) => item.api === api
      );
      if (section == null) {
        return null;
      }
      return section.name;
    },
  },
};
</script>
<style scoped>
.cell-content {
  white-space: pre-wrap;
}
.break-all {
  word-break: break-all;
}

.picture-cell {
  text-align: center;
}

.profile-picture {
  border-radius: 50%;
  width: 60px;
  height: 60px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TableCell.vue